import { createDCHook, collapseDataFromCall } from '../client';
import {
  getMonthlyEnergyReportDocumentForCustomerByDocumentId,
  getCustomerTarcomDocuments,
  downloadCustomerTarcomDocument,
  downloadDocumentByDocumentId,
  getCustomerContracts,
  getLatestCustomerContract,
} from '../services/DocumentsService';

export const useDocumentsGetMonthlyEnergyReportDocumentForCustomerByDocumentId = createDCHook(
  'getMonthlyEnergyReportDocumentForCustomerByDocumentId',
  getMonthlyEnergyReportDocumentForCustomerByDocumentId,
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: false },
);

export const useDocumentsGetCustomerTarcomDocuments = createDCHook(
  'getCustomerTarcomDocuments',
  collapseDataFromCall(getCustomerTarcomDocuments),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useDocumentsDownloadCustomerTarcomDocument = createDCHook(
  'downloadCustomerTarcomDocument',
  downloadCustomerTarcomDocument,
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: false },
);

export const useDocumentsDownloadDocumentByDocumentId = createDCHook(
  'downloadDocumentByDocumentId',
  downloadDocumentByDocumentId,
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: false },
);

export const useDocumentsGetCustomerContracts = createDCHook(
  'getCustomerContracts',
  collapseDataFromCall(getCustomerContracts),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useDocumentsGetLatestCustomerContract = createDCHook(
  'getLatestCustomerContract',
  collapseDataFromCall(getLatestCustomerContract),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);
